module.exports = __webpack_public_path__ + "files/df1e75c9de8c1b5b68f7144463afdb87.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/hue-horizontal.png
 ** module id = 829
 ** module chunks = 0
 **/